<template>
  <!-- 桶站关系列表 -->
  <div>
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" label-width="80px" :inline="true" size="mini">
        <el-form-item label="姓名">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="街道">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.streetName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作社区">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.communityName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">状态</span>
          <el-select v-model="queryParam.status" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="绑定" value="1"></el-option>
            <el-option label="解绑" value="2"></el-option>
            <el-option label="请假" value="3"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">值守类型</span>
          <el-select v-model="queryParam.dutyType" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="全班" value="1"></el-option>
            <el-option label="早班" value="2"></el-option>
            <el-option label="晚班" value="3"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">桶站状态</span>
          <el-select v-model="queryParam.garbageStationStatus" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="主桶" value="1"></el-option>
            <el-option label="代桶" value="2"></el-option>
            <el-option label="临时" value="3"></el-option>
          </el-select>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button type="success" @click="bindingRelationship">绑定</el-button>
        </el-form-item>
      </el-form>
    </div>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="bindingColumns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #photo="slotData">
        <el-image
          v-if="slotData.data.row.photo"
          style="width: 100px; height: 50px"
          :src="slotData.data.row.photo"
          :preview-src-list="[slotData.data.row.photo]"
          :key="slotData.data.row.id"
        >
          <div slot="error" class="image-slot" style="width: 100px; height: 50px">
            <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button type="primary" size="mini" @click="bindingHandleEdit(slotData.data.row)">编辑</el-button>
      </template>
    </e-table>

    <el-dialog :title="bindingText" :visible.sync="bindingDialog" :before-close="clearBindingForm">
      <el-form :model="bindingForm" :rules="staffRules" ref="ruleForm">
        <el-form-item label="街道" :label-width="staffLabelWidth" prop="streetName">
          <el-select
            v-model="bindingForm.streetName"
            placeholder="请选择街道"
            @change="getCommunityChange"
          >
            <el-option
              v-for="item in bindingCommunityNameArr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="社区" :label-width="staffLabelWidth" prop="communityName">
          <el-select v-model="bindingForm.communityName" placeholder="请选择工作社区" @change="getGSList">
            <el-option
              v-for="item in bindingResidentialQuartersArr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="桶站号" :label-width="staffLabelWidth" prop="garbageStationNo">
          <el-select v-model="bindingForm.garbageStationNo" placeholder="请选择桶站号" @change="getGSId">
            <el-option
              v-for="item in bindingGarbageStationArr"
              :key="item.id"
              :label="item.garbageStationNo"
              :value="item.garbageStationNo"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="指导员" :label-width="staffLabelWidth" prop="garbageStationSorterId">
          <el-select
            v-model="bindingForm.garbageStationSorterId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            @change="getStaffInfo"
            :loading="loading"
          >
            <el-option
              v-for="item in GSSOptions"
              :key="item.id"
              :label="item.userName + ' - ' + item.phone"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话号码" :label-width="staffLabelWidth">
          <el-input
            type="textarea"
            v-model="bindingPhone"
            style="width: 200px"
            autosize
            resize="none"
          ></el-input>
        </el-form-item>
        <div class="formDiv">
          <span>入桶时间</span>
          <el-date-picker
            v-model="bindingForm.entryTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
          <!-- 禁选今天以后的日期 :picker-options="expireTimeOption" -->
        </div>
        <div class="formDiv">
          <span>离桶时间</span>
          <el-date-picker
            v-model="bindingForm.leaveTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="19:00:00"
          ></el-date-picker>
        </div>
        <el-form-item label="状态" :label-width="staffLabelWidth">
          <el-radio-group v-model="bindingForm.status">
            <el-radio label="1">绑定</el-radio>
            <el-radio label="2">解绑</el-radio>
            <el-radio label="3">请假</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="值守类型" :label-width="staffLabelWidth">
          <el-radio-group v-model="bindingForm.dutyType">
            <el-radio label="1">全班</el-radio>
            <el-radio label="2">早班</el-radio>
            <el-radio label="3">晚班</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="桶站状态" :label-width="staffLabelWidth">
          <el-radio-group v-model="bindingForm.garbageStationStatus">
            <el-radio label="1">主桶</el-radio>
            <el-radio label="2">代桶</el-radio>
            <el-radio label="3">临时</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="staffLabelWidth">
          <el-input type="textarea" v-model="bindingForm.remark"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="clearBindingForm">取 消</el-button>
        <el-button type="primary" @click="bindingSubmit('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eTable from "@/components/table"
import { listMixin } from "@/mixins/listMixin"
import { httpAction } from "@/api/manage"
import { convertTime } from '@/utils/util'
export default {
  components: { eTable },
  mixins: [listMixin],
  data () {
    return {
      // 禁选今天以后的日期
      // expireTimeOption: {
      //   disabledDate (date) {
      //     return date.getTime() - 8.64e6 >= Date.now()
      //   },
      // },
      url: {
        list: '/gssRelationMange/queryPage',
        queryArea: "/address/street/list",
        queryResidentialQuarters: "/address/community/list",
        // getStationSorterDetail: "/garbageStationSorter/detail/",
        searchGss: '/garbageStationSorter/queryGss',
        saveBindingInfo: '/gssRelationMange/saveOrUpdate',
        getGarbageStationNo: "/garbageStation/garbageStation/list",
      },
      staffLabelWidth: "80px",
      staffRules: {
        garbageStationSorterId: [
          { required: true, message: "请填写姓名", trigger: "change" }
        ],
        streetName: [
          { required: true, message: '请选择街道', trigger: 'change' }
        ],
        communityName: [
          { required: true, message: '请选择工作社区', trigger: 'change' }
        ],
        garbageStationNo: [
          { required: true, message: '请选择桶站', trigger: 'change' }
        ],
      },
      bindingColumns: [
        { field: "streetName", label: "街道" },
        { field: "communityName", label: "工作社区" },
        { field: "garbageStationNo", label: "桶站" },
        { field: "userName", label: "指导员" },
        { field: "phone", label: "手机号", width: 200 },
        {
          width: 200,
          label: "图片",
          slotName: "photo",
          columnType: "slot",
        },
        { field: "entryTime", label: "入桶时间" },
        { field: "leaveTime", label: "离桶时间" },
        { field: "status", label: "状态" },
        { field: "dutyType", label: "值守类型" },
        { field: "garbageStationStatus", label: "桶站状态" },
        { field: "remark", label: "备注", width: 200, tooltip: true },
        {
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      bindingText: "",
      bindingDialog: false,
      bindingCommunityNameArr: [],
      bindingResidentialQuartersArr: [],
      bindingGarbageStationArr: [],
      garbageStationSorterName: "",
      GSSOptions: [],
      bindingPhone: "",
      bindingForm: {
        communityName: '',
        garbageStationNo: "",
        garbageStationSorterId: "",
        garbageStationId: "",
        dutyType: "",
        garbageStationStatus: "",
        status: "",
        entryTime: '',
        leaveTime: '',
        remark: '',
      },
      statusCode: {
        1: "绑定",
        2: "解绑",
        3: "请假",
      },
      dutyTypeCode: {
        1: "全班",
        2: "早班",
        3: "晚班",
      },
      garbageStationStatusCode: {
        1: "主桶",
        2: "代桶",
        3: "临时",
      },
    }
  },
  updated () {
    this.dataSource.forEach(item => {
      if (Number(item.status)) item.status = this.statusCode[item.status]
      if (Number(item.dutyType)) item.dutyType = this.dutyTypeCode[item.dutyType]
      if (Number(item.garbageStationStatus)) item.garbageStationStatus = this.garbageStationStatusCode[item.garbageStationStatus]
    })
  },
  methods: {
    async bindingRelationship () {
      this.bindingText = "添加绑定关系"
      this.bindingDialog = true
      let { code, data } = await httpAction(this.url.queryArea, {}, "get")
      if (code === 200) {
        this.bindingCommunityNameArr = data
      } else {
        this.$message.warning("请求失败,请重新尝试")
      }
    },
    async getCommunityChange (val) {
      if (this.bindingForm.communityName) this.bindingForm.communityName = ""
      let { id } = this.bindingCommunityNameArr.find(
        (item) => item.name === val
      )
      this.bindingForm.streetId = id
      let { data } = await httpAction(
        this.url.queryResidentialQuarters,
        { wlStreetId: [id] },
        "post"
      )
      this.bindingResidentialQuartersArr = data
    },
    async getGSList (val) {
      this.bindingForm.garbageStationNo = ""
      let { id } = this.bindingResidentialQuartersArr.find(
        (item) => item.name === val
      )
      let { data } = await httpAction(
        this.url.getGarbageStationNo,
        { communityId: id },
        "post"
      )
      this.bindingGarbageStationArr = data
    },
    getGSId (val) {
      let { id } = this.bindingGarbageStationArr.find(
        (item) => item.garbageStationNo === val
      )
      this.bindingForm.garbageStationId = id
    },

    async remoteMethod (query) {
      if (query !== "") {
        this.loading = true
        let res = await httpAction(
          `${this.url.searchGss}?userName=${query}&status=1`,
          {},
          "get"
        )
        if (res.code === 200) {
          this.loading = false
          this.GSSOptions = res.data
        } else {
          this.$message.warning = "请联系管理员"
        }
      } else {
        this.GSSOptions = []
      }
    },
    getStaffInfo (val) {
      let findInfo = this.GSSOptions.find((item) => item.id === val)
      console.log(findInfo)
      this.bindingPhone = findInfo?.phone
    },
    async bindingHandleEdit (row) {
      row.status = row.status ? this.editForin(this.statusCode, row.status) + "" : ''
      row.dutyType = row.dutyType ? this.editForin(this.dutyTypeCode, row.dutyType) + "" : ''
      row.garbageStationStatus = row.garbageStationStatus ? this.editForin(
        this.garbageStationStatusCode,
        row.garbageStationStatus
      ) + "" : ''
      this.remoteMethod(row.userName)
      this.bindingText = "编辑绑定关系"
      this.bindingDialog = true
      this.bindingPhone = row.phone
      // row.status = row.status + "";
      // row.garbageStationStatus = row.garbageStationStatus + "";
      // row.dutyType = row.dutyType + "";
      this.bindingForm = { ...row }
      console.log(row)
      let { code, data } = await httpAction(this.url.queryArea, {}, "get")
      if (code === 200) {
        this.bindingCommunityNameArr = data
      } else {
        this.$message.warning("请求失败,请重新尝试")
      }
      let communityId = data.find((item) => item.name === row.streetName)
      let { data: data1 } = await httpAction(
        this.url.queryResidentialQuarters,
        { wlStreetId: [communityId.id] },
        "post"
      )
      this.bindingResidentialQuartersArr = data1
      let garbageStationId = data1.find(
        (item) => item.name === row.communityName
      )
      let { data: data2 } = await httpAction(
        this.url.getGarbageStationNo,
        { communityId: garbageStationId.id },
        "post"
      )
      this.bindingGarbageStationArr = data2
    },
    editForin (obj, row) {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          if (row === obj[key]) return key
        }
      }
    },
    bindingSubmit (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          const timeReg = /^(\d{4})/
          if (this.bindingForm.entryTime ? !timeReg.test(this.bindingForm.entryTime) : "") this.bindingForm.entryTime = convertTime(this.bindingForm.entryTime)
          if (this.bindingForm.leaveTime ? !timeReg.test(this.bindingForm.leaveTime) : "") this.bindingForm.leaveTime = convertTime(this.bindingForm.leaveTime)
          this.bindingForm.phone = this.bindingPhone
          let res = await httpAction(
            this.url.saveBindingInfo,
            this.bindingForm,
            "post"
          )
          if (res.code === 200) {
            this.$message.success("操作成功")
            this.clearBindingForm()
            this.loadData(1)
          } else {
            this.$message.warning(res.msg)
          }
        } else {
          this.$message.error("缺少必填项")
          return false
        }
      })
    },
    clearBindingForm () {
      this.dataSource.forEach((item) => {
        item.status = Number(item.status)
          ? this.statusCode[item.status]
          : item.status
        item.dutyType = Number(item.dutyType)
          ? this.dutyTypeCode[item.dutyType]
          : item.dutyType
        item.garbageStationStatus = Number(item.garbageStationStatus)
          ? this.garbageStationStatusCode[item.garbageStationStatus]
          : item.garbageStationStatus
      })
      this.bindingDialog = false
      this.bindingForm = {
        garbageStationNo: "",
        garbageStationSorterId: "",
        garbageStationId: "",
        dutyType: "",
        garbageStationStatus: "",
        status: "",
        entryTime: '',
        leaveTime: '',
        remark: '',
      }
      this.bindingResidentialQuartersArr = []
      this.bindingGarbageStationArr = []
      this.GSSOptions = [],
        this.bindingPhone = ""
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate()
      })
    }
  },
};
</script>

<style scoped lang="scss">
.search_wrap {
  margin: 10px 0;
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
.formDiv {
  margin-bottom: 22px;
  span {
    width: 80px;
    line-height: 36px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    font-weight: 700;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    cursor: default;
  }
}
</style>